import { ModalService } from '@app/plugins/iview-modal-modify/service';
import ItemForm from '@shared/components/modal/modal-recipient';
import { RecipientService } from '@db/services/RecipientService';
import i18n from '@app/plugins/i18n';

class RecipientModalService extends ModalService {
  constructor() {
    super(RecipientService);
  }

  select({ value, range_from_one }) {
    return this.$open({
      title: i18n.t('shared.component.recipient_form.button.add_recipients'),
      width: this.size.large,
      render: (h) =>
        h(ItemForm, {
          props: {
            store: range_from_one
              ? 'mailer/mailings/form/recipients_range'
              : 'mailer/mailings/form/recipients',
            value: value
          },
          on: {
            success: (data) => {
              this.$emit('success', data);
              this.modal.remove();
            }
          }
        })
    });
  }
}

const instance = new RecipientModalService();
export { instance as RecipientModalService };
